<div class="field">
	<div class="info-row">
		<div class="wrap-group">
			<div class="info">
				{{ 'PROMPTUARY.EVOLUTION_RECORD.TITLE' | translate }}
			</div>
			<promptuary-filling-instructions-warning></promptuary-filling-instructions-warning>
		</div>
	</div>

	<div class="evolution-record zk-mt-1">
		<autosave-textarea
			ngDefaultControl
			[formControl]="unifiedPromptuary.form.get('serviceEvolution')"
			[fetchInitialValue]="false"
			[initialValue]="unifiedPromptuary.form.get('serviceEvolution').value"
			[placeholder]="'PROMPTUARY.PLACEHOLDERS.PROMPTUARY' | translate"
			property="serviceEvolution"
			service="autoSaveField"
			[showQuality]="showQuality"
			[quality]="unifiedPromptuary.serviceEvolutionQuality"
			[minLength]="10"
			[appointment]="autoSaveData"
			[appointmentData]="appointment"
			[canRecordWithSpeechToText]="showSpeechToText"
			(valueSaved)="onPromptuaryEvolutionSaved()"
			(valueSaving)="onPromptuaryEvolutionSaving()"
			(usedSpeechToText)="unifiedPromptuary.wasSpeechToTextUsed = true"
		></autosave-textarea>
	</div>
</div>
